import { FILE_ACCEPT } from '@/constant';
import { memo, useCallback, useRef } from 'react';

import Button from '.';

type UploadButtonProps = {
	onClickUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
	label?: string;
	className?: string;
	multiple?: boolean;
};

const UploadButton = ({
	onClickUpload,
	label = '업로드',
	className,
	multiple = true,
}: UploadButtonProps) => {
	const inputRef = useRef<HTMLInputElement>(null);

	const onclickUpload = useCallback(() => {
		const inputRefCurrent =
			inputRef && inputRef.current ? inputRef.current : null;
		inputRefCurrent && inputRefCurrent.click();
	}, []);

	return (
		<>
			<Button
				secondary
				className={`min-w-[86px] ${className}`}
				onClick={onclickUpload}
			>
				{label}
			</Button>
			<input
				type="file"
				className="hidden"
				ref={inputRef}
				multiple={multiple}
				onChange={onClickUpload}
				accept={FILE_ACCEPT}
				onClick={(e: any) => {
					e.target.value = null;
				}}
			/>
		</>
	);
};

export default memo(UploadButton);
